// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d687b1b3","523":"1a54c404","526":"2e8cdcf6"}[chunkId] + ".chunk.js";
};